exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".month-detail-modal[data-v-300211dd] .ant-modal-title {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n.month-detail-modal[data-v-300211dd] .ant-modal-body {\n  min-height: 590px;\n  padding: 10px 24px;\n}\n.month-detail-modal[data-v-300211dd] .ant-modal-footer {\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-top: 1px solid #ececec;\n}\n.month-detail-modal[data-v-300211dd] .ant-table-hide-scrollbar {\n  width: 100.7% !important;\n}\n", ""]);

// exports
